import { FC } from 'react'
import { createDataset } from '../../helpers/others'
import s from './Loading.module.css'

const Loading: FC<LoadingProps> = (props) => {
  const { inline } = props

  return <div {...createDataset({ inline })} className={s.root} />
}

type LoadingProps = {
  inline?: boolean
}

export { Loading }
export type { LoadingProps }
